function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

var Placeholder = /*#__PURE__*/function (_React$Component) {
  _inherits(Placeholder, _React$Component);

  var _super = _createSuper(Placeholder);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _super.apply(this, arguments);
  }

  _createClass(Placeholder, [{
    key: "render",
    value: function render() {
      var _cls;

      var _this$props = this.props,
          prefix = _this$props.prefix,
          className = _this$props.className,
          type = _this$props.type,
          image = _this$props.image,
          title = _this$props.title,
          description = _this$props.description,
          children = _this$props.children,
          others = _objectWithoutProperties(_this$props, ["prefix", "className", "type", "image", "title", "description", "children"]);

      var classNames = cls((_cls = {}, _defineProperty(_cls, "".concat(prefix, "placeholder"), true), _defineProperty(_cls, "".concat(prefix, "placeholder-").concat(type), true), _defineProperty(_cls, className, !!className), _cls));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames
      }, obj.pickAttrs(others)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "placeholder-image")
      }, /*#__PURE__*/React.createElement("img", {
        src: image
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "placeholder-title")
      }, title), description && type === 'normal' ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "placeholder-description")
      }, description) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "placeholder-children")
      }, children));
    }
  }]);

  return Placeholder;
}(React.Component);

_defineProperty(Placeholder, "propTypes", {
  prefix: PropTypes.string,

  /**
   * 额外的样式名 会附加到 root dom 上
   */
  className: PropTypes.string,

  /**
   * 类型
   */
  type: PropTypes.oneOf(['normal', 'mini']),

  /**
   * 占位插画
   */
  image: PropTypes.string.isRequired,

  /**
   * 占位标题
   */
  title: PropTypes.string.isRequired,

  /**
   * 占位描述
   */
  description: PropTypes.string
});

_defineProperty(Placeholder, "defaultProps", {
  prefix: 'next-',
  type: 'normal'
});

Placeholder.NO_CONTACT = '//img.alicdn.com/tfs/TB1Qn.cfuH2gK0jSZFEXXcqMpXa-162-156.png';
Placeholder.NO_TASK = '//img.alicdn.com/tfs/TB12lcbfET1gK0jSZFrXXcNCXXa-180-142.png';
var Configured = ConfigProvider.config(Placeholder);
Configured.displayName = 'Placeholder';
export default Configured;